import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.stringify.js";
import { testDownstreamConnection } from "@/service/sync-manage";
import { formatTime, systemName } from "./sync-utils";
export default {
  name: "sync-overview-tab",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    unitCode: {
      type: String,
      default: ""
    },
    overview: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      connectionStatusMap: {},
      probingSystems: {}
    };
  },
  computed: {
    overviewDownstreams() {
      return this.overview.downstreams || [];
    },
    totalMemberCount() {
      return this.overview.totalMemberCount || 0;
    },
    alertTotalCount() {
      const rootCauseTotal = this.rootCauseAlertTotal();
      if (rootCauseTotal !== null) return rootCauseTotal;
      return this.overviewDownstreams.reduce((total, item) => total + this.downstreamProblemCount(item), 0);
    },
    unitMismatchCount() {
      const explicitCount = this.sumRootCauseField("unitCodeNotMatchedCount");
      if (explicitCount !== null) return explicitCount;
      return Math.min(this.sumDownstreamField("failedCount"), this.alertTotalCount);
    },
    multipleMatchedCount() {
      const explicitCount = this.sumRootCauseField("multipleMatchedCount");
      if (explicitCount !== null) return explicitCount;
      return Math.max(this.alertTotalCount - this.unitMismatchCount, 0);
    }
  },
  watch: {
    overviewDownstreams: {
      immediate: true,
      handler() {
        this.syncOverviewConnectionStatuses();
      }
    },
    unitCode() {
      this.syncOverviewConnectionStatuses();
    }
  },
  methods: {
    formatTime,
    systemName,
    toNumber(value) {
      const numberValue = Number(value);
      return Number.isFinite(numberValue) ? numberValue : 0;
    },
    firstNumber(source, fields) {
      for (const field of fields) {
        if (source[field] !== undefined && source[field] !== null) {
          return this.toNumber(source[field]);
        }
      }
      return null;
    },
    // 状态总览告警拆分以后端根因字段为准：单位未匹配和多重匹配分别独立计数。
    sumRootCauseField(field) {
      const overviewCount = this.firstNumber(this.overview, [field]);
      if (overviewCount !== null) return overviewCount;
      const matchedItems = this.overviewDownstreams.filter(item => Object.prototype.hasOwnProperty.call(item, field));
      if (!matchedItems.length) return null;
      return matchedItems.reduce((total, item) => total + (this.firstNumber(item, [field]) || 0), 0);
    },
    // “存在 N 条同步告警”使用两个根因字段求和，和告警处理页签角标保持同一口径。
    rootCauseAlertTotal() {
      const unitCodeNotMatchedCount = this.sumRootCauseField("unitCodeNotMatchedCount");
      const multipleMatchedCount = this.sumRootCauseField("multipleMatchedCount");
      if (unitCodeNotMatchedCount === null && multipleMatchedCount === null) {
        return null;
      }
      return (unitCodeNotMatchedCount || 0) + (multipleMatchedCount || 0);
    },
    // 单个业务系统是否告警只看 overview 根因字段；接口未返回根因字段时，再回退旧统计口径兼容历史数据。
    downstreamRootCauseAlertCount(item) {
      const unitCodeNotMatchedCount = this.firstNumber(item, ["unitCodeNotMatchedCount"]);
      const multipleMatchedCount = this.firstNumber(item, ["multipleMatchedCount"]);
      if (unitCodeNotMatchedCount === null && multipleMatchedCount === null) {
        return null;
      }
      return (unitCodeNotMatchedCount || 0) + (multipleMatchedCount || 0);
    },
    sumDownstreamField(field) {
      return this.overviewDownstreams.reduce((total, item) => total + this.toNumber(item[field]), 0);
    },
    shortSystemName(system) {
      const names = {
        UC: "UC",
        IHOTEL: "iHotel",
        ICATER: "iCater"
      };
      return names[system] || systemName(system);
    },
    isPushSystem(item) {
      const channelText = String(item.channelType || item.syncMode || item.syncDirection || item.channelName || "").toUpperCase();
      if (channelText) {
        return !channelText.includes("PULL") && !channelText.includes($t("h9gt2", "拉取"));
      }
      return ["UC", "ICATER"].includes(item.downstreamSystem);
    },
    isWarning(item) {
      const rootCauseAlertCount = this.downstreamRootCauseAlertCount(item);
      if (rootCauseAlertCount !== null) return rootCauseAlertCount > 0;
      return this.downstreamProblemCount(item) > 0;
    },
    // 状态总览的“异常/正常”只取决于测试连通性接口；但一旦存在告警，卡片始终优先展示告警。
    cardStatus(item) {
      if (this.isWarning(item)) return "warning";
      return this.isConnectionFailed(item) ? "error" : "success";
    },
    cardStatusText(item) {
      const status = this.cardStatus(item);
      if (status === "warning") return $t("f3oc2", "告警");
      return status === "error" ? $t("gody2", "异常") : $t("is6t2", "正常");
    },
    isConnectionFailed(item) {
      var _this$connectionStatu;
      return Boolean(((_this$connectionStatu = this.connectionStatusMap[item.downstreamSystem]) === null || _this$connectionStatu === void 0 ? void 0 : _this$connectionStatu.failed) === true);
    },
    // 顶部统计卡片红字按新口径仅展示 failedCount，且三套系统文案统一为“失败”。
    downstreamFailedCount(item) {
      return this.toNumber(item.failedCount);
    },
    downstreamFailedName() {
      return $t("fy1g2", "失败");
    },
    downstreamProblemCount(item) {
      const explicitCount = this.firstNumber(item, ["alertCount", "pendingAlertCount", "unresolvedAlertCount"]);
      if (explicitCount !== null) return explicitCount;
      return this.toNumber(item.failedCount) + this.toNumber(item.unackedCount);
    },
    downstreamProblemName(system) {
      return system === "IHOTEL" ? $t("hm7p2", "挂起") : $t("fy1g2", "失败");
    },
    channelText(item) {
      if (item.channelName) return item.channelName;
      if (this.isPushSystem(item)) return $t("ww49bya", "Webhook 推送");
      return `${this.shortSystemName(item.downstreamSystem)}${" " + $t('a7su624', '主动拉取') + ""}`;
    },
    channelClass(item) {
      return this.isPushSystem(item) ? "blue" : "purple";
    },
    deploymentText(item) {
      if (item.deploymentType) {
        const deploymentType = String(item.deploymentType).toUpperCase();
        if (deploymentType === "SAAS") return "SaaS";
        if (["PRIVATE", "PRIVATIZATION"].includes(deploymentType)) {
          return $t("ibzji3", "私有化");
        }
        return item.deploymentType;
      }
      return this.isPushSystem(item) ? "SaaS" : $t("ibzji3", "私有化");
    },
    // 状态总览三类下游卡片统一展示“最近推送”，字段取值不再按拉取/推送系统切换。
    statusTime(item) {
      return item.lastPushTime || item.lastStatusTime || item.lastAckTime;
    },
    normalizeTodaySuccessRate(value) {
      const rate = this.toNumber(value);
      if (rate <= 0) return 0;
      return rate <= 1 ? Math.round(rate * 100) : Math.round(rate);
    },
    // 今日推送按接口新字段展示：次数取 todaySyncedMemberCount，成功率取 todaySuccessRate。
    todayPushText(item) {
      const todayCount = this.firstNumber(item, ["todaySyncedMemberCount", "successCount"]);
      const rate = item.todaySuccessRate !== undefined && item.todaySuccessRate !== null ? this.normalizeTodaySuccessRate(item.todaySuccessRate) : (() => {
        const successCount = this.toNumber(item.successCount);
        const failedCount = this.toNumber(item.failedCount);
        const total = successCount + failedCount;
        return total ? Math.round(successCount / total * 100) : 100;
      })();
      return `${todayCount || 0}${" " + $t('ltpfzk7', '次 · 成功率') + " "}${rate}%`;
    },
    loginText(item) {
      return item.loginMethod || "iWork SSO";
    },
    buildConnectionPayload(item) {
      return {
        unitCode: this.unitCode,
        downstreamSystem: item.downstreamSystem,
        webhookEndpoint: item.webhookEndpoint || "",
        downstreamBaseUrl: item.downstreamBaseUrl || ""
      };
    },
    setConnectionStatus(item, payload, failed) {
      this.$set(this.connectionStatusMap, item.downstreamSystem, {
        failed,
        checkedAt: Date.now(),
        requestKey: JSON.stringify(payload)
      });
    },
    // 总览卡片使用静默探活更新“正常/异常”状态，避免进入页面时为每个系统弹出重复错误提示。
    async probeConnectionStatus(item, force = false) {
      var _this$connectionStatu2, _this$connectionStatu3;
      if (!(item !== null && item !== void 0 && item.downstreamSystem) || !this.unitCode) return;
      const payload = this.buildConnectionPayload(item);
      const requestKey = JSON.stringify(payload);
      const system = item.downstreamSystem;
      if (!force && this.probingSystems[system] === requestKey) return;
      if (!force && ((_this$connectionStatu2 = this.connectionStatusMap[system]) === null || _this$connectionStatu2 === void 0 ? void 0 : _this$connectionStatu2.requestKey) === requestKey && (_this$connectionStatu3 = this.connectionStatusMap[system]) !== null && _this$connectionStatu3 !== void 0 && _this$connectionStatu3.checkedAt) {
        return;
      }
      this.$set(this.probingSystems, system, requestKey);
      try {
        const {
          data: {
            result,
            retVal
          }
        } = await testDownstreamConnection(payload, {
          headers: {
            nomsg: true
          }
        });
        this.setConnectionStatus(item, payload, !(result === 0 && retVal !== null && retVal !== void 0 && retVal.success));
      } catch (error) {
        this.setConnectionStatus(item, payload, true);
      } finally {
        if (this.probingSystems[system] === requestKey) {
          this.$delete(this.probingSystems, system);
        }
      }
    },
    syncOverviewConnectionStatuses(force = false) {
      if (!this.active) return;
      this.overviewDownstreams.forEach(item => {
        this.probeConnectionStatus(item, force);
      });
    }
  }
};